<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-title
        >Exportok (hetente törlődnek)</v-expansion-panel-title
      >
      <v-expansion-panel-text>
        <v-list>
          <v-list-item v-for="file in files" :key="file">
            <v-list-item-title>
              <v-btn block @click="downloadFile(file)" color="rsz500">
                <v-icon>mdi-download</v-icon> {{ file }}
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-expansion-panel-text>
    </v-expansion-panel>

    <admin-panel></admin-panel>

    <v-expansion-panel>
      <v-expansion-panel-title>Versenyek</v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-btn block @click="newForm()">Új</v-btn>
        <v-data-table
          :headers="headers"
          :items="competitions"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:[`item.name`]="{ item }">
            {{ item.name }}
          </template>
          <template v-slot:[`item.fillable_from`]="{ item }">
            {{ formatDate(item.fillable_from) }}
          </template>
          <template v-slot:[`item.fillable_to`]="{ item }">
            {{ formatDate(item.fillable_to) }}
          </template>
          <template v-slot:[`item.is_published`]="{ item }">
            <v-chip :color="item.is_published ? 'success' : 'error'">
              {{ item.is_published ? 'Publikálva' : 'Nem publikálva' }}
            </v-chip>
          </template>
          <template v-slot:[`item.is_form`]="{ item }">
            <v-chip :color="item.is_form ? 'success' : 'error'">
              {{ item.is_form ? 'Csak link' : 'Verseny' }}
            </v-chip>
          </template>
          <template v-slot:[`item.is_archived`]="{ item }">
            <v-chip :color="item.is_archived ? 'warning' : 'default'">
              {{ item.is_archived ? 'Archivált' : 'Aktív' }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn @click="editCompetition(item)">Verseny szerkesztése</v-btn>
            <v-btn @click="editForm(item)" v-if="!item.is_published"
              >Form szerkesztése</v-btn
            >
            <v-btn @click="publishCompetitionDialog(item)" v-if="!item.is_published">Publikálás</v-btn>
            <v-btn @click="exportCompetition(item)" v-if="item.is_published"
              >Export</v-btn
            >
            <v-btn @click="archiveCompetitionDialog(item)" v-if="item.is_published">
              {{ item.is_archived ? 'Visszaállítás' : 'Archiválás' }}
            </v-btn>
            <v-btn
              @click="deleteCompetitionDialog(item)"
              v-if="!item.is_published"
              >Törlés</v-btn
            >
          </template>
        </v-data-table>
      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-title>Felhívás</v-expansion-panel-title>
      <v-expansion-panel-text>
        <MdEditor
          v-model="felhivasContent"
          language="en-US"
          noUploadImg
          style="min-height: 500px"
        />
        <v-btn class="mt-4" @click="saveFelhivas">Mentés</v-btn>
      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-title>Intézmények</v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-btn block @click="newInstitution()" class="mb-4">Új intézmény</v-btn>
        <v-data-table
          :headers="institutionHeaders"
          :items="filteredInstitutions"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="institutionSearch"
              label="Keresés"
              class="mx-4"
              hint="Keresés név, kód, város vagy ország szerint"
              persistent-hint
            ></v-text-field>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn @click="editInstitution(item)" class="mr-2">Szerkesztés</v-btn>
          </template>
        </v-data-table>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>

  <v-dialog v-model="formDialog" max-width="1000px">
    <v-card>
      <v-card-title
        >{{ editMode ? 'Verseny szerkeszése' : 'Új verseny' }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          Verseny neve:
          <v-text-field
            v-model="competition.name"
            outlined
            dense
          ></v-text-field>
          Kezdési dátum:
          <v-date-input v-model="competition.fillable_from"></v-date-input>
          Fejezési dátum:
          <v-date-input v-model="competition.fillable_to"></v-date-input>
          <v-checkbox label="Form? (ha igen, akkor csak linken keresztül érhető el)"  v-model="competition.is_form"></v-checkbox>
          Leírás:
          <MdEditor
            v-model="competition.description"
            language="en-US"
            noUploadImg
          />
          Ajánlott irodalom:
          <MdEditor
            v-model="competition.reading"
            language="en-US"
            noUploadImg
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="saveOrAddCompetition">
          {{ editMode ? 'Mentés' : 'Létrehozás' }}
        </v-btn>
        <v-btn @click="closeFormDialog">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="publishDialog">
    <v-card>
      <v-card-title>Biztosan szeretné publikálni?</v-card-title>
      <v-card-text>
        A form publikálása által a versenyzőknek látható lesz maga a form. Ezen
        kívül megát a formot nem lesz lehetséges szerkeszteni. Biztosan
        publikálja?
      </v-card-text>
      <v-card-actions>
        <v-btn @click="publishCompetitionFn">Publikálás</v-btn>
        <v-btn @click="() => this.publishDialog = false">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="deleteDialog">
    <v-card>
      <v-card-title>Biztosan szeretné törölni?</v-card-title>
      <v-card-text>
        A verseny törlésével minden lementett adat elveszik, biztosan szeretné?
      </v-card-text>
      <v-card-actions>
        <v-btn @click="deleteCompetitionHandler()">Törlés</v-btn>
        <v-btn @click="() => this.deleteDialog = false">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="archiveDialog">
    <v-card>
      <v-card-title>
        {{ archiveTarget && archiveTarget.is_archived ? 'Biztosan visszaállítja?' : 'Biztosan archiválja?' }}
      </v-card-title>
      <v-card-text>
        {{ archiveTarget && archiveTarget.is_archived
          ? 'A verseny visszaállítása által ismét látható lesz a versenyzők számára.'
          : 'Az archiválás által a verseny elrejtésre kerül a versenyzők elől, de az adminisztrátori felületen megmarad.' }}
      </v-card-text>
      <v-card-actions>
        <v-btn @click="archiveCompetitionFn">
          {{ archiveTarget && archiveTarget.is_archived ? 'Visszaállítás' : 'Archiválás' }}
        </v-btn>
        <v-btn @click="() => this.archiveDialog = false">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="institutionDialog" max-width="600px">
    <v-card>
      <v-card-title>
        {{ institutionEditMode ? 'Intézmény szerkesztése' : 'Új intézmény' }}
      </v-card-title>
      <v-card-text>
        <v-form ref="institutionForm">
          <v-text-field
            v-model="institution.title"
            label="Intézmény neve"
            required
          ></v-text-field>
          <v-text-field
            v-model="institution.value"
            label="Érték"
            required
          ></v-text-field>
          <v-text-field
            v-model="institution.code"
            label="Kód"
            required
          ></v-text-field>
          <v-text-field
            v-model="institution.city"
            label="Város"
            required
          ></v-text-field>
          <v-text-field
            v-model="institution.country"
            label="Ország"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="saveInstitution">
          {{ institutionEditMode ? 'Mentés' : 'Létrehozás' }}
        </v-btn>
        <v-btn @click="closeInstitutionDialog">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="deleteInstitutionDialogVisible" max-width="500px">
    <v-card>
      <v-card-title>Biztosan törli az intézményt?</v-card-title>
      <v-card-text>
        A törlés nem vonható vissza, és az intézményhez tartozó összes adat is törlődik.
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="deleteInstitution">Törlés</v-btn>
        <v-btn @click="deleteInstitutionDialogVisible = false">Mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  getCompetitionsForms,
  postCompetition,
  putCompetition,
  deleteCompetition,
  publishCompetition,
  archiveCompetition,
  getExports,
  makeExport,
  getAllInstitutions,
  createInstitution,
  updateInstitution,
  deleteInstitution
} from '../services/adminServices'
import { getDynamics, putDynamics } from '../services/dynamicsService'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { MdEditor } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'
import AdminPanel from '../components/AdminPanel.vue'
import { VList, VListItem } from 'vuetify/lib/components/index.mjs'

export default {
  components: {
    VDateInput,
    MdEditor,
    AdminPanel,
    VList,
    VListItem,
  },
  data() {
    return {
      adapter: null,
      formDialog: false,
      editMode: false,
      exportDialog: false,
      currentCompId: null,
      publishDialog: false,
      deleteDialog: false,
      archiveDialog: false,
      archiveTarget: null,
      files: [],
      felhivasContent: '',
      headers: [
        { title: 'Név', align: 'center', sortable: true, value: 'name' },
        { title: 'Kezdő dátum', align: 'center', value: 'fillable_from' },
        { title: 'Végző dátum', align: 'center', value: 'fillable_to' },
        { title: 'Publikálva?', align: 'center', value: 'is_published' },
        { title: 'Csak Linken?', align: 'center', value: 'is_form' },
        { title: 'Archivált?', align: 'center', value: 'is_archived' },
        {
          title: 'Műveletek',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      competitions: [],
      competition: {
        name: null,
        startDate: null,
        endDate: null,
        description: '',
        isPublished: false,
        is_form: false,
      },
      institutionDialog: false,
      institutionEditMode: false,
      deleteInstitutionDialogVisible: false,
      institutionSearch: '',
      currentInstitutionId: null,
      institutionHeaders: [
        { title: 'Név', value: 'title' },
        { title: 'Érték', value: 'value' },
        { title: 'Kód', value: 'code' },
        { title: 'Város', value: 'city' },
        { title: 'Ország', value: 'country' },
        { title: 'Műveletek', value: 'actions', sortable: false }
      ],
      institutions: [],
      institution: {
        title: '',
        value: '',
        code: '',
        city: '',
        country: ''
      }
    }
  },
  created() {
    this.getCompetitionData()
    this.getExportData()
    this.getInstitutionsData()
    this.getFelhivasContent()
  },
  computed: {
    filteredInstitutions() {
      if (!this.institutionSearch) return this.institutions

      const search = this.institutionSearch.toLowerCase()
      return this.institutions.filter(institution => {
        return (
          institution.title?.toLowerCase().includes(search) ||
          institution.value?.toLowerCase().includes(search) ||
          institution.code?.toLowerCase().includes(search) ||
          institution.city?.toLowerCase().includes(search) ||
          institution.country?.toLowerCase().includes(search)
        )
      })
    }
  },
  methods: {
    async getCompetitionData() {
      const comps = await getCompetitionsForms()
      this.competitions = comps.map((e) => {
        return {
          id: e.id,
          name: e.name,
          fillable_from: new Date(e.fillable_from),
          fillable_to: new Date(e.fillable_to),
          description: e.description,
          reading: e.reading,
          is_published: e.is_published,
          is_archived: e.is_archived,
        }
      })
    },
    async getExportData() {
      const exports = await getExports()
      this.files = exports
    },
    async getFelhivasContent() {
      const result = await getDynamics('felhivas')
      if (result) this.felhivasContent = result.content
    },
    async saveFelhivas() {
      await putDynamics('felhivas', this.felhivasContent)
    },
    formatDate(date) {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
      const readableDate = new Intl.DateTimeFormat('hu-HU', options).format(
        date
      )
      return readableDate
    },
    editForm(competition) {
      this.$router.push({
        name: 'admin-form',
        params: { competitionId: competition.id },
      })
    },
    downloadFile(file) {
      // Same-origin fallback: prod build has no VUE_APP_API_URL, so resolve to
      // /api/... (matches the axios client). Encode the filename — exports
      // contain spaces (e.g. "Comp export 2026_6_4_12_30.xlsx").
      const base = process.env.VUE_APP_API_URL || ''
      window.open(
        `${base}/api/export-download/${encodeURIComponent(file)}`,
        '_blank'
      )
    },
    editCompetition(competition) {
      this.formDialog = true
      this.editMode = true
      this.competition = {
        id: competition.id,
        name: competition.name,
        fillable_from: new Date(competition.fillable_from),
        fillable_to: new Date(competition.fillable_to),
        description: competition.description || '',
        reading: competition.reading || '',
        is_published: competition.is_published,
        is_archived: competition.is_archived,
      }
    },
    publishCompetitionDialog(competition) {
      this.publishDialog = true
      this.currentCompId = competition.id
    },
    async publishCompetitionFn() {
      if(await publishCompetition(this.currentCompId)){
        this.publishDialog = false
        this.getCompetitionData()
      }
    },
    confirmOrCancelDialog(shouldConfirm) {
      if (shouldConfirm) {
        this.publishCompetitionFn()
      }
      this.publishDialog = false
    },
    archiveCompetitionDialog(item) {
      this.archiveDialog = true
      this.archiveTarget = item
    },
    async archiveCompetitionFn() {
      if (await archiveCompetition(this.archiveTarget.id)) {
        this.archiveDialog = false
        this.archiveTarget = null
        this.getCompetitionData()
      }
    },
    async exportCompetition(competition) {
      await makeExport(competition.id)
      await this.getExportData()
    },
    newForm() {
      this.formDialog = true
      this.editMode = false
      this.competition = {
        name: null,
        fillable_from: null,
        fillable_to: null,
        description: '',
        reading: '',
        isPublished: false,
        is_form: false,
      }
    },
    closeFormDialog() {
      this.formDialog = false
    },
    async saveOrAddCompetition() {
      if (this.editMode) {
        if(await putCompetition(this.competition)){
          this.closeFormDialog()
        }
        this.getCompetitionData()
      } else {
        if(await postCompetition(this.competition)){
          this.closeFormDialog()
        }
      }
      this.getCompetitionData()
    },
    deleteCompetitionDialog(item) {
      this.deleteDialog = true
      this.currentCompId = item.id
    },
    async deleteCompetitionHandler() {
      if(await deleteCompetition(this.currentCompId)){
        this.deleteDialog = false
      }
      this.getCompetitionData()
    },
    async getInstitutionsData() {
      const institutions = await getAllInstitutions()
      if (institutions) {
        this.institutions = institutions
      }
    },
    newInstitution() {
      this.institutionDialog = true
      this.institutionEditMode = false
      this.institution = {
        title: '',
        value: '',
        code: '',
        city: '',
        country: ''
      }
    },
    editInstitution(item) {
      this.institutionDialog = true
      this.institutionEditMode = true
      this.currentInstitutionId = item.id
      this.institution = { ...item }
    },
    closeInstitutionDialog() {
      this.institutionDialog = false
      this.institution = {
        title: '',
        value: '',
        code: '',
        city: '',
        country: ''
      }
    },
    async saveInstitution() {
      if (this.institutionEditMode) {
        if (await updateInstitution(this.institution)) {
          this.closeInstitutionDialog()
          this.getInstitutionsData()
        }
      } else {
        if (await createInstitution(this.institution)) {
          this.closeInstitutionDialog()
          this.getInstitutionsData()
        }
      }
    },
    deleteInstitutionDialog(item) {
      this.deleteInstitutionDialogVisible = true
      this.currentInstitutionId = item.id
    },
    async deleteInstitution() {
      if (await deleteInstitution(this.currentInstitutionId)) {
        this.deleteInstitutionDialogVisible = false
        this.getInstitutionsData()
      }
    },
  },
}
</script>
